import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardContent, TextField, Button, Box, Alert } from '@mui/material';
import apiClient from '../utils/apiClient';
import { PBM } from '../types';

const PBMAdd = () => {
    const navigate = useNavigate();
    const [pbm, setPbm] = useState<PBM>({ pbmName: '' });
    const [error, setError] = useState<string>();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(undefined);
        
        try {
            await apiClient.post('/api/PBM', pbm);
            navigate('/pbm');
        } catch (error) {
            if (error instanceof Error && error.message) {
                try {
                    const errorData = JSON.parse(error.message);
                    setError(errorData.Message || 'Failed to create PBM');
                } catch {
                    setError(error.message || 'An error occurred');
                }
            } else {
                setError('An error occurred');
            }
        }
    };

    return (
        <Box sx={{ maxWidth: 500, mx: 'auto', mt: 4 }}>
            <Card>
                <CardHeader title="Add New PBM" />
                <CardContent>
                    <form onSubmit={handleSubmit}>
                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}
                        <TextField
                            fullWidth
                            label="PBM Name"
                            value={pbm.pbmName}
                            onChange={(e) => setPbm({ ...pbm, pbmName: e.target.value })}
                            required
                            inputProps={{ maxLength: 100 }}
                            margin="normal"
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{ mt: 2 }}
                        >
                            Save
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
}

export default PBMAdd;
